import PropTypes from 'prop-types'

/**
 * @param {string} className - classes that you want to put on the icon.
 * @param {string} color - color with which you want to paint the icon.
 * @returns {React.ReactNode} - return an Pause Icon. 
 */
export function Play(props) {
    const { className, color = 'currentColor' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="14"
      fill="none"
      viewBox="0 0 11 14"
        className={className}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M0 1.332A1 1 0 011.54.49l8.818 5.669a1 1 0 010 1.682L1.541 13.51A1 1 0 010 12.67V1.331z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}


Play.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
}